import { useState } from 'react';
import { MappingType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/mapping.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAiScheduleAccess } from '@frontend/ai-receptionist-settings';
import { useDebouncedValue } from '@frontend/design-system';
import { ManageProvidersAvailabilityBanner } from '../../components/manage-providers-availability-banner';
import { ManagePractitionersV3Table } from '../../components/ManagePractitionersV3/ManagePractitionersV3Table';
import { ScheduleSettingsSection } from '../../components/settings';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';
import { PageConfig } from '../../types';

type ManagePractitionerV3PageProps = {
  locationId?: string;
};

export const ManagePractitionersV3Page = ({ locationId }: ManagePractitionerV3PageProps) => {
  const { selectedLocationIds } = useSchedulingLocationInfo();
  const selectedLocationId = locationId || selectedLocationIds[0] || '';
  const { hasAiScheduleAccess } = useAiScheduleAccess();

  const [pageConfig, setPageConfig] = useState<PageConfig>({
    page: 1,
    limit: 10,
    searchValue: '',
  });

  const debouncedSearchValue = useDebouncedValue(pageConfig.searchValue, 400);

  const listMappingsQuery = SchedulerV3.Queries.useListMappingsQuery({
    request: {
      locationIds: [selectedLocationId],
      mappingType: MappingType.PROVIDER_APPOINTMENT_TYPE,
      showInactive: true,
    },
    options: {
      enabled: !!selectedLocationId,
    },
  });

  const isLoading = listMappingsQuery.isFetching;

  return (
    <ScheduleSettingsSection transparentInSmallMode>
      {hasAiScheduleAccess && <ManageProvidersAvailabilityBanner />}
      <ManagePractitionersV3Table
        isLoading={isLoading}
        pageConfig={pageConfig}
        mappingList={listMappingsQuery.data?.mappings || []}
        setPageConfig={setPageConfig}
        locationId={selectedLocationId}
        debouncedSearchValue={debouncedSearchValue}
        disableProviderActions={hasAiScheduleAccess}
      />
    </ScheduleSettingsSection>
  );
};
